import { ApiErrorInfo } from 'src/model/component';
import { generateStateContext } from 'src/utils/context';

interface State {
  /** 화면 위에 띄울 API 오류 알림(ApiErrorList) */
  errors: ApiErrorInfo[];
}

const initialState: State = {
  errors: [],
};

export const [AppContext, AppProvider] = generateStateContext(initialState);
